exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ba-common-root{margin:0;padding:0;height:100%;width:100%;box-sizing:border-box;z-index:1}", ""]);

// exports
